import { render, staticRenderFns } from "./VuesticSwitch.vue?vue&type=template&id=bea4cc16"
import script from "./VuesticSwitch.vue?vue&type=script&lang=js"
export * from "./VuesticSwitch.vue?vue&type=script&lang=js"
import style0 from "./VuesticSwitch.vue?vue&type=style&index=0&id=bea4cc16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-switch/VuesticSwitch.vue
// module id = yPiP
// module chunks = 41